import {ComponentFactoryResolver, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataSourcesComponent } from './components/data-sources/data-sources.component';
import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import {DataTracingDynamicComponentHelper} from '@features/data-tracing/data-tracing-dynamic-component-helper';
import {CoreModule} from '@core/core.module';
import {SharedModule} from '@shared/shared.module';
import { DataSourcesFieldHistoryDetailsComponent } from './components/data-sources-field-history-details/data-sources-field-history-details.component';
import {DataTracingService} from '@features/data-tracing/services/data-tracing.service';
import {DataSourcesRootComponent} from "@features/data-tracing/components/data-sources-root/data-sources-root.component";
import { PlatformDonutChartComponent } from './components/platform-donut-chart/platform-donut-chart.component';
import {ChartModule} from '@progress/kendo-angular-charts';
import 'hammerjs';
import {LatestDataSourcesComponent} from "@features/data-tracing/components/latest-data-sources/latest-data-sources.component";
import {ActivityRightSidebarStateService} from "@features/data-tracing/services/activity-right-sidebar-state.service";
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DataTracingV2Service } from './services/data-tracing-v2.service';
@NgModule({
  declarations: [
    DataSourcesComponent,
    DataSourcesFieldHistoryDetailsComponent,
    PlatformDonutChartComponent,
    LatestDataSourcesComponent,
    DataSourcesFieldHistoryDetailsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    CoreModule,
    ChartModule,
    MatProgressSpinnerModule
  ],
  providers : [
    DataTracingService,
    DataTracingV2Service,
    ActivityRightSidebarStateService
  ],
  exports: [
    DataSourcesComponent,
    DataSourcesFieldHistoryDetailsComponent,
    PlatformDonutChartComponent,
    LatestDataSourcesComponent,
    DataSourcesFieldHistoryDetailsComponent
  ]
})
export class DataTracingModule {
  constructor(private componentFactoryResolver: ComponentFactoryResolver) {
    RootDynamicComponentHelper.registerComponentFactoryResolver(this.componentFactoryResolver);
    DataTracingDynamicComponentHelper.init();
  }
}
